<template>
    <div class="formset">
        <el-card style="padding-bottom: 10px;">
            <p>
                <!-- <span class="required">*</span> -->
                关联直播
            </p>
            <el-button
             size="small"
             @click="openCourse"
             v-if="!this.activityInfo.courseSourceId"
             >请选择</el-button>
            <el-card
             style="width: 600px;margin-top: 10px;"
             v-if="activityInfo.live && activityInfo.live.courseSourceId">
                <div
                 class="course-card">
                    <img :src="commonUrl.imgPrefix + activityInfo.live.cover"
                    style="height: 100px;max-width: 400px;"
                    v-show="activityInfo.live.cover">
                    <div class="course-item">
                        <p>{{activityInfo.live.courseSourceName}}</p>
                        <p class="desc">
                            <span>{{activityInfo.live.teacherName}} | </span>
                            <span>{{activityInfo.live.planStartTime}}开播</span>
                        </p>
                    </div>
                    <el-link type="primary"
                     :underline="false"
                     class="course-remove"
                     @click="removeCourse"
                     >移除</el-link>
                </div>
            </el-card>
        </el-card>
        <p></p>
        <el-card style="padding-bottom: 10px;" v-show="activityInfo.live && activityInfo.live.courseSourceId">
            <p>
                <span class="required">*</span>
                进入方式</p>
            <p>
                <el-checkbox
                 v-model="activityInfo.liveBeforeStatus"
                 :true-label="1"
                 :false-label="0">进入直播前显示此表单</el-checkbox>
            </p>
            <el-card v-show="activityInfo.liveBeforeStatus">
                <p>
                    <el-checkbox
                     v-model="activityInfo.isFill"
                     :true-label="1"
                     :false-label="0"
                     @change="isFillChange">用户必须填写完报名表才能进入直播</el-checkbox>
                </p>
                <p v-if="activityInfo.isFill">
                    <el-checkbox
                     v-model="activityInfo.isAuth"
                     :true-label="1"
                     :false-label="0"
                     style="margin-left: 25px;">
                        是否认证
                    </el-checkbox>
                    <span class="desc">需要认证通过才能进入（未认证用户，将自动提交认证申请）</span>
                </p>
            </el-card>
            <p>
                <el-checkbox
                 v-model="activityInfo.liveBelowStatus"
                 :true-label="1"
                 :false-label="0"
                >在直播把手广告下方显示报名入口</el-checkbox>
            </p>
            <!-- 设置图标 -->
            <el-card v-show="activityInfo.liveBelowStatus">
                <p>
                    <el-upload
                    style="display: inline-block"
                    :action="commonUrl.uploadImg"
                    :headers="commonUrl.headers"
                    :data="mediaObj" :multiple="false"
                    :on-success="uploadSuccess"
                    :show-file-list="false"
                    accept="image/png, image/jpeg, image/jpg, image/gif">
                        <span class="required">*</span>
                        <el-button
                        type="primary"
                        size="small">设置图标</el-button>
                    </el-upload>
                    <span class="desc">支持jpg、png、gif，大小不超过500kb，推荐尺寸200*200px</span>
                </p>
                <div class="avatar-uploader">
                    <div v-show="activityInfo.liveIcon"
                    class="avatar trash">
                        <img :src="commonUrl.imgPrefix + activityInfo.liveIcon"
                            class="cover">
                        <div class="trashdom"></div>
                        <i class="el-icon-delete avatar_edit" @click.stop="removeCover"></i>
                    </div>
                </div>           
            </el-card>
            
            <!-- 在直播导航栏显示报名入口 -->
            <p>
                <el-checkbox
                 v-model="activityInfo.liveNavigationStatus"
                 :true-label="1"
                 :false-label="0"
                >在直播导航栏显示报名入口</el-checkbox>
            </p>
            <el-card style="padding-top: 10px;"
             v-show="activityInfo.liveNavigationStatus">
                <el-form
                 label-width="80px"
                 label-position="right"
                >
                    <el-form-item label="导航名称"
                     required>
                        <el-input
                         v-model="activityInfo.navigationName"
                         maxlength="5"
                         show-word-limit
                         style="width: 400px;"></el-input>
                    </el-form-item>
                    <el-form-item label="标签">
                        <el-input
                         v-model="activityInfo.label"
                         maxlength="5"
                         show-word-limit
                         style="width: 400px;"></el-input>
                        <span class="desc">为空时，不显示</span>
                    </el-form-item>
                </el-form>           
            </el-card>
        </el-card>
        <!--选择课程源组件-->
		<course-select ref='courseSelect' :userType='2' :isSingle='true' :selfType='1'
		 :selfOffline="0"
         @select-submit='choiceCourseCallback'></course-select>
    </div>
</template>

<script scoped>
import commonApi from '@/api/common'
import courseSelect from '@/components/selectSource/selectCourseOrgin'
export default{
    components: {
        courseSelect
    },
    data() {
        return {
            commonUrl: commonApi.commonUrl,
            mediaObj: {
                mediaJson: JSON.stringify({
                    type: 0,
                })
            },
            activityInfo: {
                live: {},
                courseSourceId: '', // 课程源
                liveBeforeStatus: 0, // 是否在进入直播前显示此表单（0 -否 1-是）
                isFill: 0, // 用户必须填写完报名表才能进入直播（0-否 1-是）
                isAuth: 0, // 需要认证通过才能进入（0-否 1-是）
                liveBelowStatus: 0, // 在直播把手广告下方显示报名入口(0-否 1-是)
                liveNavigationStatus: 0, // 在直播导航栏显示报名入口(0-否 1-是)
                liveIcon: '', // 图标
                navigationName: '', // 导航名称
                label: '' // 标签
            }
        }
    },
    methods: {
        getActivityData() {
            return this.activityInfo
        },
        setActivityData(data) {
            this.activityInfo = data
        },
        isFillChange(val) {
            if(!val) {
                this.activityInfo.isAuth = 0
            }
        },
        uploadSuccess(res) {
             res = this.$apiOldResDeal(res)
            if (!res.Success) {
                this.$message.error(res.Msg)
            } else {
                this.activityInfo.liveIcon = res.Data.url
                this.$message.success('上传成功')
            }
        },
        removeCover() {
            this.activityInfo.liveIcon = ''
        },
        //选择课程回调 
        choiceCourseCallback(res) {
            if(!res || !res[0]) { return }
            let course = res[0]
            this.activityInfo.live = {
                teacherName: course.teacherName,
                planStartTime: course.planStartTime,
                courseSourceName: course.title,
                courseSourceId: course.id
            }
            this.activityInfo.courseSourceId = course.id
        },
        // 打开课程弹框
        openCourse() {
            this.$refs.courseSelect.open("选择课程")
        },
        removeCourse() {
            this.activityInfo ={
                live: {},
                courseSourceId: '', // 课程源
                liveBeforeStatus: 0, // 是否在进入直播前显示此表单（0 -否 1-是）
                isFill: 0, // 用户必须填写完报名表才能进入直播（0-否 1-是）
                isAuth: 0, // 需要认证通过才能进入（0-否 1-是）
                liveBelowStatus: 0, // 在直播把手广告下方显示报名入口(0-否 1-是)
                liveNavigationStatus: 0, // 在直播导航栏显示报名入口(0-否 1-是)
                liveIcon: '', // 图标
                navigationName: '', // 导航名称
                label: '' // 标签
            }
        }
    }
}
</script>

<style  type="text/less" lang="less" scoped>
.desc{
    color: gray;
    font-size: 12px;
}

.required{
    color: #FD686D;
    font-size: 16px;
}
.form-item{
    display: flex;
    .label{
        width: 80px;
    }
}
.formset{
    .avatar{
        width: 100px;
        height: 100px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .cover{
        display: flex;
    }
    .desc{
        line-height: 1.2;
        margin: 5px 0 16px;
    }
}
.course-card{
    margin-top: 10px;
    display: flex;
    .course-item{
        flex: 1;
        margin-right: 40px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/operateManage/signupform/components/formset.vue